import type { ReploElementType } from "schemas/generated/element";

import { skipToken } from "@tanstack/react-query";
import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import { elementRouter } from "@v2/trpc/routes/element";

export function useElementsMetadataByType(type: ReploElementType) {
  const { project } = useCurrentProjectContext();
  const projectId = project?.id;

  const { data: elementMetadata = [] } =
    elementRouter.listAllElementsMetadata.useQuery(
      projectId ? { projectId } : skipToken,
    );

  return elementMetadata.filter((element) => element.type === type);
}
